import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
    icon: {},
    size: { default: 24 },
    color: {}
  },
  setup(__props: any) {

const props = __props

const iconStyle = computed(() => ({
  fontSize: typeof props.size === 'number' ? `${props.size}px` : props.size,
  color: props.color,
  lineHeight: 1,
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["app-icon mdi", __props.icon]),
    style: _normalizeStyle(iconStyle.value),
    "aria-hidden": "true"
  }, null, 6))
}
}

})